import { useQuery } from '@tanstack/react-query';
import { shiftsGetApplicationEvents } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useShiftApplicationEvents = (
  calendarYear: number,
  calendarWeek: number
) =>
  useQuery({
    queryFn: () =>
      extractData(
        shiftsGetApplicationEvents({
          path: { calendarYear, calendarWeek },
        })
      ),
    queryKey: ['shifts', 'applicationEvents', calendarYear, calendarWeek],
  });
